import SellSide from './SellSide.component';

export default SellSide;
